/**
 * Finds the corresponding component definition that matches the JSON Schema's
 * basic type. The following sequence of definitions are respected:
 * - If the schema property includes an $id, a matching component is searched
 *   and returned if found.
 * - If a custom type definition is declared, the first match is returned.
 * - If no custom definitions are found, a default definition is returned.
 * @param {Object} definitions - A lookup object for definitions.
 * @param {Object} schema - The JSON Schema object or property.
 * @param {React.Component} type - The type used to search for a definition.
 */
const findDefinition = (definitions, schema, type, opts = {}) => {
  const { root = false } = opts;
  const definition = definitions[type];

  const withProps = (Component, ownProps) => ({
    Component,
    ownProps,
  });

  let Found = withProps(definition.default, undefined);

  const foundCustomGeneric = definition.customs.find(Component => {
    return (
      !Component.props.id && !Component.props.root && !Component.props.format
    );
  });

  if (foundCustomGeneric) {
    Found = withProps(
      foundCustomGeneric.props.render,
      foundCustomGeneric.props,
    );
  }

  if (root) {
    const foundRoot = definition.customs.find(Component => {
      return !!Component.props.root;
    });
    if (foundRoot) {
      Found = withProps(foundRoot.props.render, foundRoot.props);
    }
  }

  if (schema.id) {
    const foundExact = definition.customs.find(Component => {
      return Component.props.id === schema.id;
    });
    if (foundExact) {
      Found = withProps(foundExact.props.render, foundExact.props);
    }
  }

  if (schema.format) {
    const foundExact = definition.customs.find(Component => {
      return Component.props.format === schema.format;
    });
    if (foundExact) {
      Found = withProps(foundExact.props.render, foundExact.props);
    }
  }

  return Found;
};

export default findDefinition;
